export default {
    symbolsKeyValue: "Абв",
    layout: [
        ["я", "ш", "е", "р", "т", "и", "у", "і", "о", "п"],
        ["а", "с", "д", "ф", "г", "ч", "й", "к", "л"],
        ["з", "х", "ц", "в", "б", "н", "м"]
    ],
    specialKeysLayout: []
};
